module.exports = __webpack_public_path__ + "static/media/acceuil_2.a3523d48.jpg";